/**
 * Created by administrator on 2019/4/10.
 */
const state = {
  user: {
    name: '123',
    id: '',
    width: 0,
    height: 0
  },
  path: '',
  uid: '',
  canvasId: ''
}

export default state
